import { BaseWebComponentController } from '../../../../../framework/BaseWebComponentController';
import { templateProductTrialsOverlayWindowsApp } from '../view/template';
import { InProductTrialsOverlayWindowsAppWebComponent } from '../component/InProductTrialsOverlayWindowsAppWebComponent';
import { InProductTrialsOverlayWindowsAppView } from '../view/InProductTrialsOverlayWindowsAppView';
import { InProductTrialsOverlayWindowsAppRepository } from '../repository/InProductTrialsOverlayWindowsAppRepository';
import { InProductTrialsAdditionalUserSettings } from '../types/InProductTrialsAdditionalUserSettings';

export class InProductTrialsOverlayWindowsAppController extends BaseWebComponentController {
  public component: InProductTrialsOverlayWindowsAppWebComponent;
  public view: InProductTrialsOverlayWindowsAppView;
  public viewConstructor: typeof InProductTrialsOverlayWindowsAppView;
  public dataRepository: InProductTrialsOverlayWindowsAppRepository;
  public dataRepositoryConstructor: typeof InProductTrialsOverlayWindowsAppRepository;

  constructor(component: InProductTrialsOverlayWindowsAppWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: InProductTrialsOverlayWindowsAppView,
      viewTemplate: templateProductTrialsOverlayWindowsApp,
      dataRepositoryConstructor: InProductTrialsOverlayWindowsAppRepository,
    });
  }

  async getDataForView(): Promise<InProductTrialsAdditionalUserSettings> {
    return await this.dataRepository.getAdditionalUserSettingsForInProductTrials();
  }
}
